module.exports = __webpack_public_path__ + "static/media/cv.0714bdfd.jpg";